import React, { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import api from "@/lib/api";

export default function StudentsPage() {
  const [students, setStudents] = useState(null);

  useEffect(() => {
    api.get("/meetings/directory/students").then((r) => setStudents(r.data)).catch(() => setStudents([]));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8" data-testid="students-page">
      <h1 className="font-heading text-2xl font-semibold text-white flex items-center gap-2"><GraduationCap className="w-6 h-6 text-fuchsia-400" /> Students</h1>
      <p className="text-sm text-slate-400 mt-1">Learners who have attended your live classes.</p>

      <div className="glass-panel rounded-2xl divide-y divide-white/5 mt-6" data-testid="students-list">
        {students === null && <p className="p-6 text-sm text-slate-400 text-center">Loading...</p>}
        {students?.length === 0 && <p className="p-6 text-sm text-slate-400 text-center">No students yet — once learners attend your Live Classes, they'll show up here.</p>}
        {students?.map((s) => (
          <div key={s.user_id} className="flex items-center gap-3 p-3.5" data-testid={`student-row-${s.user_id}`}>
            <div className="w-8 h-8 rounded-full bg-fuchsia-500/20 flex items-center justify-center text-fuchsia-300 text-xs font-bold shrink-0">{s.name?.[0]?.toUpperCase() || "?"}</div>
            <span className="flex-1 text-sm text-white truncate">{s.name}</span>
            <span className="text-xs text-slate-400">{s.classes_attended} class{s.classes_attended !== 1 ? "es" : ""} attended</span>
          </div>
        ))}
      </div>
    </div>
  );
}
